/**
 * A ping's click asking for its session's popup (notifications cleanup, Petr 2026-10-31). The calendar answers once it
 * can (Calendar registers): the click may have just brought the student from another page, or opened Shovel, so the
 * asking goes on for a while. Resolves false if the popup never opened.
 */

const TRY_EVERY_MS = 150;
const GIVE_UP_MS = 8000;

type SessionOpener = (plannedTaskId: number) => boolean;

let opener: SessionOpener | null = null;

/** The calendar's side: returns the unsubscribe. */
export const onOpenSession = (open: SessionOpener) => {
  opener = open;
  return () => {
    if (opener === open) opener = null;
  };
};

export const openSessionPopup = (plannedTaskId: number) =>
  new Promise<boolean>(resolve => {
    const startedAt = Date.now();
    const attempt = () => {
      if (opener?.(plannedTaskId)) return resolve(true);
      if (Date.now() - startedAt >= GIVE_UP_MS) return resolve(false);
      window.setTimeout(attempt, TRY_EVERY_MS);
    };
    attempt();
  });
